import React from 'react';
import { Link } from 'react-router-dom';
import ColumnaBotoneraItem from '../ColumnaBotoneraItem.js';
import { CamposToFechaCorta } from '../../funciones/FuncionesFecha.js';
import { DescripcionFuente } from '../../funciones/FuncionesInformacion.js';
import styles from '../CuadroListaEditable.module.css';
import styleCols from './TablaLinks.module.css';

const TablaLinks = (props) => {
  const lista = props.lista;
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;
  const subtitulo = props.subtitulo;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  };

  const descripcionLink = (item) => {
    let descripcion = '';
    descripcion = item.fuenteInformacion ? DescripcionFuente(item.fuenteInformacion) : 'link';
    return descripcion;
  };

  return (
    <React.Fragment>
      <tr>
        <td colSpan="3" className={`${styles.subtitulo}`}>
          {subtitulo}
        </td>
      </tr>
      <tr key="0" className={`${styles.titulos}`}>
        <td className={`${styleCols.tipo}`}>Tipo</td>
        <td className={`${styleCols.fecha}`}>Fecha</td>
        <td className={`${styleCols.link}`}>Link</td>
      </tr>
      {lista.map((item) => (
        <tr className={`${styles.valores} ${esIdElegido(item.id) && styles.elegido}`} key={item.id}>
          <td className={`${styleCols.tipo}`}>{item.tipoLink && item.tipoLink.descripcion}</td>
          <td className={`${styleCols.fecha}`}>
            {CamposToFechaCorta(item.anioPublicacion, item.mesPublicacion, item.diaPublicacion)}
          </td>
          <td className={`${styleCols.link}`}>
            <Link to={item.url} target="_blank" rel="noopener noreferrer" about={item.url}>
              {descripcionLink(item)}
            </Link>
          </td>
          <ColumnaBotoneraItem
            idItem={item.id}
            onEditarItem={onEditarItem}
            onEliminarItem={onEliminarItem}
          />
        </tr>
      ))}
    </React.Fragment>
  );
};

export default TablaLinks;
